import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Product, Terminal } from 'rest-client';

import { TripStateModel } from '@app/modules/core/states/trip-state/trip.model';
import { BookingData } from '@core/states/booking-state/booking.model';

import {
  TIMEZONE,
  getSpanishTimezoneUTC,
} from '../../const/date-picker.consts';
import { Router } from '@angular/router';

@Component({
  selector: 'bkg-summary-booking-data',
  templateUrl: './summary-booking-data.component.html',
})
export class SummaryBookingDataComponent implements OnInit {

  constructor(private router: Router) { }
  @Input() bookingData: BookingData;
  @Input() tripData: TripStateModel;
  @Input() readOnly: boolean;
  @Input() isUrbanParkin: boolean;
  @Input() isConfirmationStep: boolean;
  @Input() isPremium: boolean;
  @Input() selectedVoucherCode: any;
  @Input() vouchers: any;

  @Output() modifyBookingData = new EventEmitter<void>();

  TIMEZONE_UTC_START: string;
  TIMEZONE_UTC_END: string;

  ngOnInit(): void {
    this.TIMEZONE_UTC_START = getSpanishTimezoneUTC(this.bookingData.startDate);
    this.TIMEZONE_UTC_END = getSpanishTimezoneUTC(this.bookingData.endDate);
  }

  onClickModifyButton(): void {
    this.modifyBookingData.emit();
  }

  get diffTimeZone(): boolean {
    const timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
    return timezone === TIMEZONE ? false : true;
  }

  get inTerminal(): string | null {
    if (!this.tripData) return null;
    return this.getTerminalName(this.tripData.common_in_terminal);
  }

  get outTerminal(): string | null {
    if (!this.tripData) return null;
    return this.getTerminalName(this.tripData.common_out_terminal);
  }

  get difTerminal(): boolean {
    return (
      this.inTerminal &&
      this.outTerminal &&
      this.inTerminal !== this.outTerminal
    );
  }

  get hasPassengers(): boolean {
    return !!this.tripData.in_passengers && !!this.tripData.out_passengers;
  }

  get hasFlightNumber(): boolean {
    return !!this.tripData.flight_number;
  }

  private getTerminalName(commonTerminalId: number): string | null {
    let name;
    if (this.bookingData?.place && commonTerminalId) {
      const { products } = this.bookingData.place;

      products.forEach((product: Product): void => {
        if (product.terminals.length <= 1) return null;
        const terminalName = product.terminals.find(
          (terminal: Terminal): boolean =>
            terminal.common_terminal_id === commonTerminalId
        );
        if (terminalName) {
          name = terminalName?.name_short;
        }
      });
    }
    return name;
  }

  get collapseByVoucherSelected() {
    const currentUrl = this.router.url;

    if (currentUrl.includes('/products')) return false;

    if ((currentUrl.includes('/services') || currentUrl.includes('/traveler-data')) && !this.selectedVoucherCode && this.vouchers) {
      return true;
    }
    return false
  }
}
